const DAYS = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

const SHORT_DAYS = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};

/*
 * D -> 1-9-31
 * DD -> 01-09-31
 * DDD -> Mon-Sun
 * DDDD -> Monday-Sunday
 * M -> 1-12
 * MM -> 01-12
 * MMM -> localized full month name
 * YY -> 00-99
 * YYYY -> 1900-2099
 */
export const formatDate = (
  date: string | null | undefined,
  format = 'D MMM YYYY',
  locale = 'en',
): string | null | undefined => {
  if (date) {
    let jsDate = new Date(date);

    // Safari does not recognize Dates in format "2022-04-14 00:00"
    if (Number.isNaN(jsDate.getTime()) && typeof date === 'string') {
      jsDate = new Date(date.split(' ')[0]);
    }

    const YYYY = jsDate.getFullYear();
    const YY = `${YYYY}`[2] + `${YYYY}`[3];

    // use getMonth instead of getUTCMonth to be client timezone agnostic
    const M = jsDate.getMonth() + 1;
    const MM = `${M}`.length === 1 ? `0${M}` : M;
    const MMM = jsDate.toLocaleString(locale, { month: 'long' });

    // use getDate instead of getUTCDate to be client timezone agnostic
    const D = jsDate.getDate();
    const DD = `${D}`.length === 1 ? `0${D}` : D;
    // @ts-ignore
    const DDDD = DAYS[D];
    // @ts-ignore
    const DDD = SHORT_DAYS[D];

    const tokens = { YYYY, YY, MMM, MM, M, DDDD, DDD, DD, D };

    // Replace tokens once so localized month names cannot be treated as format tokens.
    return format.replace(/YYYY|YY|MMM|MM|M(?![a-z])|DDDD|DDD|DD|D(?![a-z])/g, (token) =>
      String(tokens[token as keyof typeof tokens]),
    );
  }
  return date;
};
